(function () {
  const BUTTON_ORDER = [
    'shopify-pc__banner__btn-accept',
    'shopify-pc__banner__btn-decline',
    'shopify-pc__banner__btn-manage-prefs',
  ];

  function reorderPrivacyBannerButtons() {
    const container = document.querySelector(
      '.shopify-pc__banner__btns.shopify-pc__banner__btns-granular'
    );
    if (!container) return false;

    const buttons = BUTTON_ORDER.map((id) => document.getElementById(id)).filter(Boolean);
    if (buttons.length < 2) return false;

    buttons.forEach((button) => container.appendChild(button));
    return true;
  }

  function init() {
    if (reorderPrivacyBannerButtons()) return;

    const observer = new MutationObserver(() => {
      if (reorderPrivacyBannerButtons()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
